<div class="container">
    <div class="host">
        <!-- Top Banner -->
        <img class="banner" src="../../../../../assets/new/banner.jpg" alt="banner" />
        <!-- Product Item -->
        <div class="book-box" *ngFor="let book of books" fxFlex="50" fxLayoutGap="20px">
            <div matRipple class="book" (click)="onBookSelected(book.book_id)">
                <img [src]="book.image_url" alt="" class="img-contain full-wh" loading="lazy">
                <h4 *ngIf="book.title" class="title">
                    {{ book.title }}
                </h4>
            </div>
        </div>
    </div>
</div>